import React from "react";

import { Grid } from '@material-ui/core';

import BaseDialog from "../../../../../components/BaseDialog/BaseDialog";
import {PrimaryButton} from "../../../../../components/Buttons";
import {isValidString} from "../../../../../utils/utils";
import {EditExternalDepotForm} from "../../ActionButtons/VirtualdepotActions/VirtualDepotEditButton";

const MPExternalDepotModal = (props) => {
  const {
    open,
    handleClose,
    title,
    portfolio,
    formData,
    setFormData,
    modalLoading,
    handleBack,
    handleSave,
    actions,
    children,
    customClasses,
    onExited,
  } = props;

  const showDepotForm = !!formData;

  return (
    <BaseDialog
      title={showDepotForm ? 'Fremddepot hinzufügen' : title}
      open={open}
      maxWidth={showDepotForm ? 'md' : undefined}
      modalLoading={modalLoading}
      handleClose={handleClose}
      customClasses={!showDepotForm && customClasses}
      TransitionProps={{onExited: onExited}}
      actions={showDepotForm ? (
        <DepotFormActions
          handleClose={handleClose}
          handleSave={handleSave}
          handleBack={handleBack}
          formData={formData}
        />
      ) : actions}
    >
      <>
        {showDepotForm && (
          <DepotForm
            formData={formData}
            setFormData={setFormData}
            portfolio={portfolio}
          />
        )}
        {/* hide list to cache it (prevent fetch data again) */}
        <div hidden={showDepotForm} style={{width: '100%'}}>
          {children}
        </div>
      </>
    </BaseDialog>
  )
}

export default MPExternalDepotModal;

const DepotFormActions = (props) => {
  const {
    handleBack,
    handleClose,
    handleSave,
    formData,
  } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={'auto'}>
        <PrimaryButton
          onButtonClick={handleBack}
          text={'Zurück'}
          icon={<i className={'fal fa-long-arrow-left'} />}
          variant={'text'}
        />
      </Grid>
      <Grid item xs={12} sm={'auto'} style={{marginLeft: 'auto'}}>
        <PrimaryButton
          text="Abbrechen"
          variant="outlined"
          onButtonClick={handleClose}
        />
      </Grid>
      <Grid item xs={12} sm={'auto'}>
        <PrimaryButton
          text={"Speichern"}
          onButtonClick={handleSave}
          disabled={!isValidString(formData.name)}
        />
      </Grid>
    </Grid>
  )
}

const DepotForm = (props) => {
  const {
    formData,
    setFormData,
    portfolio,
  } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>Bitte geben Sie folgende Daten für das Fremddepot an.</Grid>
      <EditExternalDepotForm
        formData={formData}
        setFormData={setFormData}
        portfolio={portfolio}
      />
    </Grid>
  )
}